/**教学团队模块 */
import request from '../request/http';
/**查询教学团队列表 */
export function GetTeamList(data){
    return request({
        url: '/sp/teachingTeam/getList',
        method: 'post',
        data
    })
}
/**更新教学团队 */
export function UpdateTeachingTeam(data){
    return request({
        url: '/sp/teachingTeam/updateTeachingTeam',
        method: 'post',
        data
    })
}